import { WeddingInfoType } from "./WeddingInfo";

const firebaseStorageURL = (name: string, fileType: string = "jpg") =>
  `https://firebasestorage.googleapis.com/v0/b/marriage-1e74b.firebasestorage.app/o/20260328%2F${name}.${fileType}?alt=media&token=496b7aab-6359-4040-ba00-260b8e3a0c84`;

export const WeddingInfo20260328: WeddingInfoType = {
  common: {
    groomName: "신하용",
    brideName: "김태희",
    groomShortName: "하용",
    brideShortName: "태희",
    addressInfo: {
      name: "벨라루체 웨딩홀 서울점 2층 벨라홀",
      lat: 37.5899075,
      lon: 127.0599904,
      address: "서울시 동대문구 망우로 61",
      naverAddress:
        "https://map.naver.com/p/entry/place/1036896821?placePath=%252Fhome%253Fentry%253Dplt&searchType=place&lng=127.0599904&lat=37.5899075",
    },
    weddingDateKR: "2026월 03월 28일 (토) 17시 30분",
    weddingDate: "2026-03-28 17:30",
    groomAccountInfos: [
      {
        name: "신하용",
        bankName: "국민 은행",
        bankImage: `${process.env.PUBLIC_URL}/KookminBank.png`,
        accountNumber: "004402-04-139825",
        isGroom: true,
        familyName: "",
      },
    ],
    brideAccountInfos: [
      {
        name: "김태희",
        bankName: "농협 은행",
        bankImage: `${process.env.PUBLIC_URL}/nonghyupbank.png`,
        accountNumber: "356-1619-2087-33",
        isGroom: false,
        familyName: "",
      },
      {
        name: "김봉천",
        bankName: "하나 은행",
        bankImage: `${process.env.PUBLIC_URL}/hanabank.jpeg`,
        accountNumber: "298-911024-47107",
        isGroom: false,
        familyName: "신부 아버지",
      },
    ],
    accountInfos: [
      {
        name: "신하용",
        bankName: "국민은행",
        bankImage: `${process.env.PUBLIC_URL}/nonghyupbank.png`,
        accountNumber: "004402-04-139825",
        isGroom: true,
        familyName: "",
      },
      {
        name: "김태희",
        bankName: "농협은행",
        bankImage: `${process.env.PUBLIC_URL}/nonghyupbank.png`,
        accountNumber: "356-1619-2087-33",
        isGroom: true,
        familyName: "",
      },
    ],
    parentBGM: null,
    netflixBGM: null,
    spotifyBGM: null,
    instagramBGM: null,
  },
  /* Parent */
  parent: {
    startPhrase: "신하용 ❤️ 김태희,",
    shortPhrase: "결혼합니다",
    mainImage: firebaseStorageURL("JO__2386"),
    weddingMessage: `이유는 많았지만 답은 하나였습니다.
마음이 먼저였고, 결정은 자연스러웠습니다.

우리에게 가장 자연스러운 결정, 사랑이 답이 되었고,
망설임 없이 서로를 선택했습니다.

소중한 분들과 함께 이 순간을 나누고 싶습니다.
귀한 걸음으로 축복해 주시면 감사하겠습니다.`,
    groomFatherName: "신동욱",
    groomMotherName: "양인자",
    groomFamilyTitle: "차남",
    brideFatherName: "김봉천",
    brideMotherName: "김순숙",
    brideFamilyTitle: "딸",
    photoGalleryPhrase: "우리들의 추억들",
    photoGalleryImages: [
      firebaseStorageURL("JO__1392"),
      firebaseStorageURL("1771856255600", "png"),
      firebaseStorageURL("JO__5342"),
      firebaseStorageURL("JO__0438"),
      firebaseStorageURL("JO__2182"),
      firebaseStorageURL("1771856255194", "png"),
      firebaseStorageURL("JO__4808"),
      firebaseStorageURL("JO__2642"),
      firebaseStorageURL("JO__1342"),
      firebaseStorageURL("JO__4635"),
    ],
    poetry: "",
    endImage: firebaseStorageURL("1764142386618"),
  },
  /* Instagram */
  instagram: {
    storyImages: [
      `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
    ],
    postInfos: [
      {
        profileImage: `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        name: "영철 ❤️ 옥순",
        postImages: [
          `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        ],
        title: "우리 결혼해요! 🤵🏻👰🏻",
        caption: "모두 축하해주셔서 감사합니다.",
      },
      {
        profileImage: `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        name: "영철 ❤️ 옥순",
        postImages: [
          `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
        ],
        title: "귀한 발걸음 해주셔서 감사드립니다. 🙇🏻🙇🏻‍♀️",
        caption: "모두 축하해주셔서 감사합니다.",
      },
    ],
    gridInfo: {
      profileImage: `${process.env.PUBLIC_URL}/samples/sample-couple-9.jpg`,
      name: "Our Memories",
      startDay: "2020-01-01",
      images: [
        `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-7.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-8.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-9.jpg`,
      ],
    },
  },
  /* Spotify */
  spotify: {
    albumTitle: "영철이와 옥순이의 행복 리스트",
    albums: [
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
        title: "바다에서 함께",
        caption: "영철이랑 옥순이",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
        title: "갈대밭에서",
        caption: "풍경을 바라보며",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
        title: "노을과 함께",
        caption: "아름다운 풍경",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
        title: "영원한 사랑",
        caption: "행복",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
        title: "볼 맞대고",
        caption: "친구처럼",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        title: "노을 빛",
        caption: "황홀한 풍경",
        topRightCaption: "Love",
      },
    ],
    lyricTitle: "전하고 싶은 말",
    lyrics: [
      {
        message: `인생 가장 빛나는 날,

          소중한 분들을 모시고 기쁨을 나누면 좋겠지만
          혹 참석이 어려우시더라도 괜찮습니다.

          멀리서 축하해주신 분들과 어려운 발걸음
          해주신 분들 모두 마음에 새기고 항상 행복하게 살겠습니다.`,
        hightlightLines: [0],
        color: "bg-red-500/80",
      },
      {
        message: `이 두 사람을 지성으로 아끼고 돌봐주신
          여러 어른과 친지를 모시고 서약을 맺고자 하오니

          바쁘신 가운데 두 사람의 앞날을
          가까이에서 축복해 주시면 고맙겠습니다.

          감사합니다.`,
        hightlightLines: [3],
        color: "bg-spotify/80",
      },
      {
        message: `박영철 ♥ 이옥순

            고독한 마라톤인 줄로만 알았습니다
            재촉하지 않고 더 오래 걷자고
            
       서로의 다리에 결혼이라는 끝을 묶고
      달리기로 했습니다.

            황홀하게 기억하겠습니다. 
            출발선에 선 이 순간을`,
        hightlightLines: [0, 5, 6],
        color: "bg-yellow-500/80",
      },
    ],
    player: {
      sectionTitle: "우리들의 이야기",
      videoURL: `${process.env.PUBLIC_URL}/samples/sample-video.mp4`,
      title: "우리 결혼해요! (feat. 축하해주세요)",
      caption: "영철 ❤️ 옥순",
    },
    list: {
      sectionTitle: "인기 급상승 추억 리스트",
      images: [
        `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
      ],
      titles: [
        "바다에서 함께",
        "갈대밭에서",
        "노을과 함께",
        "영원한 사랑",
        "볼 맞대고",
        "노을 빛",
      ],
      captions: [
        "영철이랑 옥순이",
        "풍경을 바라보며",
        "아름다운 풍경",
        "행복",
        "친구처럼",
        "황홀한 풍경",
      ],
    },
    artist: {
      sectionTitle: "여러 장소 리스트",
      images: [
        `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
      ],
      titles: [
        "영원한 사랑",
        "볼 맞대고",
        "노을 빛",
        "바다에서 함께",
        "갈대밭에서",
        "노을과 함께",
      ],
      captions: [
        "행복",
        "친구처럼",
        "황홀한 풍경",
        "영철이랑 옥순이",
        "풍경을 바라보며",
        "아름다운 풍경",
      ],
    },
  },
  netflix: {
    posterInfo: {
      image: firebaseStorageURL("JO__2386"),
      title: "신하용 ❤️ 김태희 이야기 시작",
      caption: "26.3.28일 (토) pm5:30분 최초공개",
    },
    top10Info: {
      sectionTitle: "우리들의 TOP 10 시리즈",
      images: [
        firebaseStorageURL("1771856255600", "png"),
        firebaseStorageURL("JO__5342"),
        firebaseStorageURL("JO__0438"),
        firebaseStorageURL("JO__2182"),
        firebaseStorageURL("JO__4808"),
        firebaseStorageURL("JO__2642"),
        firebaseStorageURL("1771856255194", "png"),
        firebaseStorageURL("JO__1342"),
        firebaseStorageURL("JO__1392"),
        firebaseStorageURL("JO__4635"),
      ],
    },
    newHotInfo: {
      videoURL: firebaseStorageURL(
        "VIDEO_179f7fe4-f7c0-4577-80a4-c64d43dc8b25",
        "mp4",
      ),
      title: "TAE HEE ❤️ HA YONG",
      caption: `
      NEW CHAPTER

      3월 28일(토) pm 5시 30분 에피소드 공개`,
      message: `
봄날의 시작에
저희의 새로운 이야기가 열립니다.
함께해 주시면 큰 기쁨이 되겠습니다.`,
    },
    heartInfo: {
      sectionTitle: "우리가 찜한 리스트",
      titles: [],
      images: [
        firebaseStorageURL("JO__5620"),
        firebaseStorageURL("JO__6114"),
        firebaseStorageURL("JO__6160"),
        firebaseStorageURL("JO__4255"),
        firebaseStorageURL("1771856255344", "png"),
        firebaseStorageURL("JO__4740"),
        firebaseStorageURL("JO__1728"),
        firebaseStorageURL("JO__3952"),
        firebaseStorageURL("JO__0631"),
        firebaseStorageURL("JO__0838"),
      ],
      percents: [30, 20, 50, 80, 70, 10],
    },
    accountInfo: [
      {
        name: "신하용",
        bankName: "국민 은행",
        bankImage: `${process.env.PUBLIC_URL}/KookminBank.png`,
        accountNumber: "004402-04-139825",
        isGroom: true,
        familyName: "",
      },
      {
        name: "김태희",
        bankName: "농협 은행",
        bankImage: `${process.env.PUBLIC_URL}/nonghyupbank.png`,
        accountNumber: "356-1619-2087-33",
        isGroom: false,
        familyName: "",
      },
      {
        name: "김봉천",
        bankName: "하나 은행",
        bankImage: `${process.env.PUBLIC_URL}/hanabank.jpeg`,
        accountNumber: "298-911024-47107",
        isGroom: false,
        familyName: "신부 아버지",
      },
    ],
  },
};
